// Helper around fetch that refreshes expired access tokens using the
// stored refresh token. If refreshing fails, stored tokens are removed
// and the request is rejected.
export async function authFetch(
  input: RequestInfo | URL,
  init: RequestInit = {},
  token?: string
): Promise<Response> {
  const accessToken = token || localStorage.getItem('access_token');
  const refreshToken = localStorage.getItem('refresh_token');

  const makeRequest = (bearer?: string) =>
    fetch(input, {
      ...init,
      headers: {
        ...(init.headers || {}),
        ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
      },
    });

  let response = await makeRequest(accessToken || undefined);
  if (response.status !== 401 || !refreshToken) {
    return response;
  }

  // Access token expired – attempt refresh
  const refreshResponse = await fetch('/api/token/refresh/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh: refreshToken }),
  });

  if (!refreshResponse.ok) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    return response; // propagate original 401
  }

  const data = await refreshResponse.json();
  localStorage.setItem('access_token', data.access);

  return makeRequest(data.access);
}

